import React from "react"
import { Link } from "gatsby"

import logoStyles from "./logo.module.scss"

const Logo = () => {
  return (
    <div className={logoStyles.logo}>
      <Link to="/">
        <img className={logoStyles.logoImage} src={`/my_logo.png`} alt="Logo" />
      </Link>
    </div>
  )
}

export default Logo
